import { Button } from "react-bootstrap";
import { useHrStyles } from "../../Context/HRContext";
import "./ResText.css";

export default function ResText() {
  const hrStyles = useHrStyles();
  return (
    <div className="res-text-container">
      <p
        style={{
          textAlign: "justify",
          fontSize: "1em",
          paddingLeft: "1em",
          paddingRight: "1em",
          fontFamily: "'Inria Serif', serif",
          padding: "0% 20%",
          paddingTop: "2em",
        }}
      >
        At BEAMS, we understand that a home is more than just a place to
        live—it’s where memories are made and lifestyles are shaped. Our
        approach to residential building is centered around creating
        personalized spaces that reflect your unique tastes and needs. From
        modern apartments to luxurious villas, we bring your vision to life with
        meticulous attention to detail and craftsmanship. Our designs combine
        functionality, comfort, and aesthetic appeal to create homes that not
        only enhance your living experience but also stand the test of time.
        With sustainable construction practices, we ensure that your dream home
        is built to be as enduring as it is beautiful.
      </p>
      <Button
        href="/Contact"
        variant="outline-success"
        size="lg"
        className="centered-button"
      >
        Contact Us
      </Button>
      <hr style={hrStyles} />
      <div style={{ marginTop: "20px" }}></div>
    </div>
  );
}
